import Home from './Home.data-manager-dsps.vue'

export default {
  Home
}